import { render, staticRenderFns } from "./VendorManagementDashboard.vue?vue&type=template&id=1af36d58"
import script from "./VendorManagementDashboard.vue?vue&type=script&lang=js"
export * from "./VendorManagementDashboard.vue?vue&type=script&lang=js"
import style0 from "./VendorManagementDashboard.vue?vue&type=style&index=0&id=1af36d58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports